import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog, DialogTitle } from "@material-ui/core";
import { FC, useEffect, useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { FullWidthButton } from "src/framework/components/buttons";
import { STATUS_CODE } from "src/framework/providers/api";
import { notifierStore } from "src/framework/store";
import pagamentoProvider from "src/providers/pagamentos/PagamentosProvider";

import { IPixResponseType } from "src/types";
import { QRCode } from "../QRCode";

import "./styles.scss";

interface GerarQRCodePixProperties {
    codigo_venda?: string;
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const GerarQRCodePix: FC<GerarQRCodePixProperties> = ({
    codigo_venda,
    open,
    onClose,
    onConfirm
}) => {

    const [pix, setPix] = useState<IPixResponseType>();
    const [copied, setCopied] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(true)
    const [disabled, setDisabled] = useState<boolean>(false)
    
    const getPix = async (): Promise<void> => {
        try {
            setLoading(true)
            if (codigo_venda) {
                const response = await pagamentoProvider.getPix(codigo_venda)
                if (response.statusCode === STATUS_CODE.OK) {
                    setPix(response.data);
                } else {
                    notifierStore.setNotifier({
                        title: "Aviso",
                        content: response.message,
                        timeOut: 3500,
                        onClose: () => {
                            notifierStore.setOpen(false);
                            onClose();
                        }
                    })
                    notifierStore.setOpen(true)
                }
            }
            
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (open && codigo_venda) {
            getPix();
        }
    }, [open, codigo_venda]);

    return <div>
        {(open && loading === false) && <Dialog open={open} className="GerarQRCodePix" maxWidth="xs">
            <DialogTitle>Pix</DialogTitle>
            <div className="qrcode">
                {loading && <><p>Carregando...</p></>}
                {(pix && open && loading === false) && <>
                    <QRCode 
                        pix={pix} 
                        onDisabled={(_disabled) => {
                            setDisabled(_disabled)
                        }}
                    />
                </>}
            </div>
            <div className="row actions">
                <div className="X12 M6">
                    <FullWidthButton
                        onClick={() => {
                            onClose();
                        }}
                        text="Fechar"
                    />
                </div>

                <div className="X12 M6">
                        <CopyToClipboard text={pix?.url_chave || ""}
                            onCopy={() => setCopied(true)}>
                            <FullWidthButton
                                
                                startIcon={<><FontAwesomeIcon icon={faCopy} /></>}
                                color="primary"
                                variant="contained"
                                disableElevation
                                text="Copiar"
                                disabled={pix?.url_chave === "" || disabled}
                            />
                        </CopyToClipboard>
                        {copied ? <span style={{color: 'red'}}>Copied.</span> : null}
                </div>
            </div>

        </Dialog>}
    </div>
}

export { GerarQRCodePix }